import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';
import ContactBanner from 'assets/contact-banner.svg';
import WhatsappImg from 'assets/whatsapp.png';
import { AtSign, PhoneCall } from 'react-feather';
import { motion } from 'framer-motion';

export const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <WebLayout>
      {/* HERO SECTION */}
      <section className="px-6 md:px-56 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 border-b border-[#F3C72C]/30 pb-16">
          {/* LEFT SIDE */}
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center md:text-left"
          >
            <h1 className="text-5xl md:text-7xl font-extrabold text-[#0a0a0a] mb-4">
              Contact <span className="text-[#F3C72C]">Us.</span>
            </h1>

            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
              We're always excited to hear from you.
            </h2>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Send your message and someone will reach out within{' '}
              <span className="font-extrabold">3 – 4 hours</span>. If you need immediate support,
              feel free to call or chat on WhatsApp.
            </p>

            {/* CONTACT DETAILS */}
            <div className="mt-6 space-y-4">
              <div className="flex items-center gap-3">
                <PhoneCall className="h-6 w-6 text-[#F3C72C]" />
                <span className="font-semibold text-[#0a0a0a] text-lg">+256 773 558 907</span>
              </div>

              <div className="flex items-center gap-3">
                <AtSign className="h-6 w-6 text-[#F3C72C]" />
                <span className="font-semibold text-[#0a0a0a] text-lg">
                  ashitacreatives@gmail.com
                </span>
              </div>

              <div classname="flex items-center gap-3">
                <img src={WhatsappImg} alt="whatsapp" className="h-6" />
                <span className="font-semibold text-[#0a0a0a] text-lg">+256 782 692 271</span>
              </div>
            </div>

            {/* WHATSAPP BUTTON */}
            <div className="mt-10">
              <a
                href="https://wa.me/256782692271"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 rounded-xl bg-black border border-[#F3C72C] text-white font-semibold hover:bg-[#F3C72C]/10 transition-all shadow-lg"
              >
                Chat on WhatsApp
              </a>
            </div>
          </motion.div>

          {/* RIGHT SIDE ILLUSTRATION */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            className="flex justify-center md:justify-end"
          >
            <img
              src={ContactBanner}
              alt="Contact Banner"
              className="h-64 md:h-[28vw] object-contain"
            />
          </motion.div>
        </div>
      </section>

      {/* MESSAGE SECTION */}
      <section className="px-6 md:px-56 py-20">
        {/* Badge */}
        <div className="inline-block px-5 py-1 rounded-full bg-[#0a0a0a] text-[#F3C72C] border border-[#F3C72C] mb-6">
          Send us a message
        </div>

        <p className="text-lg text-gray-700 max-w-2xl mb-8">
          If you have any inquiries or concerns, describe your inquiry with as much detail as you
          can. Our team is ready to support you.
        </p>

        {/* CONTACT FORM PLACEHOLDER */}
        <div className="mt-10 mb-20">
          <div className="text-[#0a0a0a] text-lg bg-gray-100 p-6 rounded-xl border border-[#F3C72C]/20 shadow">
            <em>
              Contact form is currently unavailable. You can send an email to{' '}
              <a
                href="mailto:ashitacreatives@gmail.com"
                className="text-[#F3C72C] underline font-bold"
              >
                ashitacreatives@gmail.com
              </a>
            </em>
          </div>
        </div>
      </section>
    </WebLayout>
  );
};
